import { Statistic } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import useLotDetailsSupplementSupplyContext from "../../../../../../../hooks/useLotDetailsSupplementSupplyContext";
import { numberMask } from "../../../../../../../services/helpersMethodsService";

// import { Container } from './styles';

function CardAverageConsumeSupplementSupplyDashboard() {
  const { averageAnimalSupply } = useLotDetailsSupplementSupplyContext();
  const { translation } = useSelector((state) => state.app);
  return (
    <Statistic
      title={
        translation.lot.production.details.supplementSupply.dashboards
          .averageConsumeMO
      }
      value={`${numberMask(averageAnimalSupply, false)} kg`}
      suffix={
        translation.lot.production.details.supplementSupply.dashboards
          .suffixCabDay
      }
    />
  );
}

export default CardAverageConsumeSupplementSupplyDashboard;
